import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/maintenance/general')({
  beforeLoad: ({ context }): void => {
    // The General tab lists service plans, so it needs `service-plans:list`. A viewer without it (who
    // still cleared the parent's `service-operations:list` gate) is sent to Service operations. Mirrors
    // the parent route's permission gate; deferred until permissions are ready to avoid a false bounce.
    if (context.permissions.isReady && !context.permissions.hasPermission('service-plans:list')) {
      throw redirect({ to: '/settings/maintenance/service-operations' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/maintenance/general/pages/maintenance-general-page')),
  staticData: { titleKey: 'general' },
});
